export default __webpack_public_path__ + "static/media/YELLBO.dfea0725.png";